import { Box, Typography } from '@material-ui/core';
import utils from '../../utils';
import '../../styles/components/test/test.scss';

const Test = (props) => {
  const { data, results } = props;

  return data.map((item, idx) => {
    const { question, answers } = item;

    return (
      <div className="test__border">
        <Box mt={2}>
          <Typography
            variant="body1"
            style={{ fontWeight: 'bold' }}
            gutterBottom
          >
            {`${++idx}. ${question}`}
            <span style={{ color: 'red' }}>*</span>
          </Typography>
        </Box>

        <ul className="test__answers">
          {answers.map((_item) => {
            return (
              <li>
                <Typography variant="body1" gutterBottom>
                  <input
                    type="radio"
                    name={idx}
                    id={utils.createURLChunk(_item.text, true)}
                    value={utils.createURLChunk(_item.text, true)}
                  />
                  <label for={utils.createURLChunk(_item.text, true)}>
                    {_item.text}.
                  </label>
                </Typography>
              </li>
            );
          })}
        </ul>

        {results?.map((result) => {
          if (result.question === question) {
            if (result.isRight) {
              return <p style={{ color: 'green' }}>Правильный ответ!</p>;
            } else {
              return result.rightAnswer ? (
                <p style={{ color: 'red' }}>
                  Правильный ответ: {result.rightAnswer}.
                </p>
              ) : (
                <></>
              );
            }
          }
          return null;
        })}
      </div>
    );
  });
};

export default Test;
